const Inicio = () => {
    return (
        <h1></h1>
    )
}

export default Inicio;